<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agriculture Clinic/ ຜູ້ໃຊ້
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==9">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂຜູ້ໃຊ້">
         <div class="columns" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂຜູ້ໃຊ້</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ຊື່ເຂົ້າໃຊລະບົບ" v-if="saveAction">
                    <b-input v-model.trim="clinicusername"> </b-input>
                  </b-field>
                  <b-field label="ຊື່ເຂົ້າໃຊລະບົບ" v-if="updateAction" :disabled="updateAction==true">
                    <span style="font-size: 18px; font-weight: bold;">{{ clinicusername }}</span>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຊື່ເຕັມ">
                    <b-input v-model.trim="fullname"> </b-input>
                  </b-field>
                </div>
               <div class="column">
                  <b-field label="ເບີໂທ">
                    <b-input v-model.trim="phoneno"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ລະຫັດພະນັກງານ">
                    <b-input v-model.trim="staffid"> </b-input>
                  </b-field>
                </div>
               
              </div>
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveUser">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateUser"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveUserForm"
                        >
                          ຟອມເພີ່ມຜູ້ໃຊ້
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>

        </b-tab-item>

        <b-tab-item label="ຜູ້ໃຊ້ ທີ່ເປີດໃຊ້ງານ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຜູ້ໃຊ້ ທີ່ເປີດໃຊ້ງານ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຂົ້າໃຊ້ລະບົບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື້ເຕັມ
                      </th>

                      <th class="has-text-left " width="15%">
                        ລະຫັດພະນັກງານ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="15%">
                        ສາຂາທີ່ຮັບຜິດຊອບ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.USERNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.STAFFID }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>
                      <td>
                        {{ data.BRANCHNAME }}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  updateUserForm(
                                    data.USERID,
                                    data.USERNAME,
                                    data.FULLNAME,
                                    data.STAFFID,
                                    data.PHONENO
                                  )"
                                >ແກ້ໄຂ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-warning"
                                size="is-small"
                                @click="
                                  resetPassword(
                                    data.USERID
                                  )"
                                >ລີເຊັດລະຫັດ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  changeUserStatus(data.USERID,0)"
                                >ປິດໃຊ້ງານ
                              </b-button>
                            </b-field>
                          </b-field>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        
        <b-tab-item label="ຜູ້ໃຊ້ ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ສາຂາ ທີ່ຖືກປິດ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຂົ້າໃຊ້ລະບົບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື້ເຕັມ
                      </th>

                      <th class="has-text-left " width="15%">
                        ລະຫັດພະນັກງານ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactiveusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.USERNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.STAFFID }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              changeUserStatus(data.USERID,1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";

export default {
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    username: null,
    clinicuserid: null,
    clinicusername: null,
    oldclinicusername: null,
    fullname: null,
    oldfullname: null,
    phoneno: null,
    oldphoneno: null,
    staffid: null,
    oldstaffid: null,

    activeusers: [],
    inactiveusers: [],

    activeTab: 1,
    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,
  };
  },
  methods: {
    getCountry() {
      RestAPI.getCountry()
        .then(res => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getResponseUser() {
      RestAPI.getResponseUser(3)
        .then(res => {
          // console.log("con: "+ JSON.stringify(res.data))
          if(this.updateAction==true){
            this.userList = res.data;
            this.userList.push(this.selectedUser)
          }
         
          this.userList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onCountrySelected() {
      // this.isProvinceSelected = false;
      console.log("selected country: "+ JSON.stringify(this.selectedCountry))
      console.log("selected country ID: "+ JSON.stringify(this.selectedCountry.ID))
      
      this.getProvince();
      this.selectedProvince= null;
      
    },
    getProvince(){
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then(res => {
          // console.log("country selected...")
          this.provinceList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveUser() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (this.username === null || this.fullname === null || this.phoneno === null || this.staffid === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          clinicusername: this.clinicusername,
          clinicuserpassword: this.sha2(this.phoneno),
          fullname: this.fullname,
          staffid: this.staffid,
          phoneno: this.phoneno,
          roleid: 10,
          username: this.username
        };
        RestAPI.saveClinicUser(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate username") {
              this.$swal(
                "ຊື່ໃຊ້ລະບົບຊຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate fullname") {
              this.$swal(
                "ຊື່ເຕັມຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate staffid") {
              this.$swal(
               "ລະຫັດພະນກງານຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate phoneno") {
              this.$swal(
               "ເບີໂທຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }
              
            this.$swal("ສ້າງ User ສຳເລັດ!", "", "success");
            
            this.clinicusername= null;
            this.fullname= null;
            this.staffid= null;
            this.phoneno= null;
            this.getClinicUser();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getClinicUser() {
      RestAPI.getClinicUser()
        .then(res => {
          // console.log("lsit:"+ JSON.stringify(res.data))
          this.activeusers = res.data.activeusers;
          this.inactiveusers = res.data.inactiveusers;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateUserForm(USERID, USERNAME, FULLNAME, STAFFID, PHONENO) {
     
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.clinicuserid = USERID;
      this.clinicusername = USERNAME;
      this.oldclinicusername = USERNAME;
      this.oldfullname = FULLNAME;
      this.fullname = FULLNAME;
      this.staffid = STAFFID;
      this.oldstaffid = STAFFID;
      this.phoneno = PHONENO;
      this.oldphoneno = PHONENO;
      
    },
    openSaveUserForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.clinicusername = null;
      this.fullname = null;
      this.staffid = null;
      this.phoneno = null;
    },
    updateUser() {
      if (this.fullname === null || this.staffid === null || this.phoneno === null) {
      this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } 
      var params = {
        userid: this.clinicuserid,
        oldfullname: this.oldfullname,
        fullname : this.fullname,
        oldstaffid : this.oldstaffid,
        staffid : this.staffid,
        oldphoneno : this.oldphoneno,
        phoneno : this.phoneno,
        username: this.username
      };

      console.log("pa: " + JSON.stringify(params))
     
      RestAPI.updateClinicUser(params)
        .then(res => {
          console.log("data: "+ JSON.stringify(res.data))
        
            if (res.data == "duplicate fullname") {
              this.$swal(
                "ຊື່ເຕັມຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate staffid") {
              this.$swal(
               "ລະຫັດພະນກງານຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate phoneno") {
              this.$swal(
               "ເບີໂທຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }

            this.$swal("ແກ້ໄຂ User ສຳເລັດ!", "", "success");

          this.activeTab = 1;
          this.saveAction = true;
          this.updateAction = false;
          this.clinicusername = null;
          this.fullname = null;
          this.staffid = null;
          this.phoneno = null;
          this.getClinicUser();
        })
        .catch(error => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    changeUserStatus(userid,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            userid: userid,
            status: status,
            username: this.username
          };
          // console.log("par: "+ JSON.stringify(params ))
          RestAPI.changeUserClinicStatus(params)
            .then(() => {
              
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getClinicUser();

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    
    resetPassword(userid){
      this.$swal({
        title: "ຕ້ອງານລີເຊັດລະຫັດຜ່ານ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            userid: userid,
            username: this.username
          };
          RestAPI.resetPassword(params)
            .then(() => {
              
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getClinicUser();
    this.getCountry();
    this.getResponseUser();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
